<ng-container *ngIf="!pending; else skeleton">
  <section class="rs-es-first-section">
    <div class="row">
      <div class="columns small-12">
        <h1 class="rs-txt-c2">
          {{ "mobile.urBuying.userAccess.title" | translate }}
        </h1>
        <div class="rs-panel-big rs-bg-c2 clearfix">
          <p>{{ "mobile.urBuying.userAccess.description" | translate }}</p>
          <p class="rs-txt-s3 rs-txt-details">
            <strong>
              {{ "mobile.urBuying.userAccess.detailsTitle" | translate }}
            </strong>
            {{ "mobile.urBuying.userAccess.details" | translate }}
          </p>
          <div>
            <p class="text-right">
              <a
                (click)="deactivateAllUsers()"
                href="javascript:void(0)"
                role="button"
              >
                {{ "mobile.urBuying.userAccess.deactivateBtn" | translate }}
              </a>
            </p>
          </div>
          <div
            *ngFor="let user of users; let i = index"
            class="panel rs-bg-grey2"
          >
            <div class="rs-flex-row rs-flex-middle">
              <div class="rs-flex-column rs-flex-shrink">
                <p>
                  <i
                    aria-hidden="true"
                    class="icon-Smartphone icon-lh rs-txt-purple rs-txt-s7"
                  ></i>
                </p>
              </div>
              <div class="rs-flex-column">
                <p class="rs-txt-purple rs-font-pxB" id="ac-switch-text{{ i }}">
                  {{ user.msisdn }}
                </p>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <div class="rs-switch">
                  <input
                    [(ngModel)]="user.hasRight"
                    id="switch{{ i }}"
                    name="switch{{ i }}"
                    role="switch"
                    type="checkbox"
                  />
                  <label
                    aria-labelledby="ac-switch-text{{ i }}"
                    for="switch{{ i }}"
                  >
                    <span aria-hidden="true" class="rs-switch-active">{{
                      "mobile.urBuying.userAccess.switchYesValue" | translate
                    }}</span>
                    <span aria-hidden="true" class="rs-switch-inactive">{{
                      "mobile.urBuying.userAccess.switchNoValue" | translate
                    }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="rs-me"></div>
          <button (click)="confirmChanges()" class="rs-btn">
            {{ "mobile.urBuying.userAccess.confirmationBtn" | translate }}
          </button>
        </div>
      </div>
    </div>
  </section>
</ng-container>

<ng-template #skeleton>
  <mprd-user-access-management-skeleton
    *ngIf="pending"
  ></mprd-user-access-management-skeleton>
</ng-template>
